import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { Button, Base, t, Block } from 'zf-web-components';
import { Icons } from 'zf-web-components/icons';
import { RootContext } from '@stores';
import { PrivacyPolicy } from './policy';
import styles from './index.module.less';
import type { FormProps, FormValues } from './types';
import type { ReactElement } from 'react';

function WecomLoginComponent({ store }: FormProps): ReactElement {
  const [form] = Base.Form.useForm<FormValues>();
  const { local } = useContext(RootContext);

  return (
    <div className={styles.formWrap}>
      <Base.Space className={styles.back} size={2} onClick={store.onBackClick.bind(store)}>
        <Icons name='LeftOutlined' />
        <span>{t('返回')}</span>
      </Base.Space>
      <Block if={!store.qrCodeVisible}>
        <div className={styles.loginMethodName}>{store.loginMethodName}</div>
        <Base.Form
          className={styles.form}
          size={'large'}
          layout='vertical'
          form={form}
          requiredMark={false}
          initialValues={{ code: local.code, id: local.id }}
          onValuesChange={store.onValuesChange.bind(store)}
        >
          <Base.Form.Item
            label={<span className={styles.label}>{t('企业码')}</span>}
            name='code'
            rules={store.getValidationRules('code')}
            normalize={value => value.trim()}
          >
            <Base.Input
              className={styles.input}
              variant='borderless'
              placeholder={t('请输入企业码')}
              onKeyUp={event => store.onInputKeyUp(event, form)}
            />
          </Base.Form.Item>
          <Button
            label={t('登录')}
            loading={store.isLoginBtnLoading}
            autoInsertSpace={false}
            type='primary'
            onClick={store.onLoginButtonClick.bind(store, form)}
            className={styles.loginBtn}
          />
        </Base.Form>
      </Block>
      <div className={styles.wecomQr}>
        <div id='login-qrcode' style={{ display: store.qrCodeVisible ? 'block' : 'none' }}></div>
      </div>
      <Block if={!store.qrCodeVisible}>
        <PrivacyPolicy />
      </Block>
    </div>
  );
}

export const WecomLogin = observer(WecomLoginComponent);
